/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Use_External_EmojisInputs */



/**
* | output |
* | --- |
* | "Use External Emojis" |
*
* @param {Leveling_Perm_Use_External_EmojisInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_use_external_emojis = /** @type {((inputs?: Leveling_Perm_Use_External_EmojisInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Use_External_EmojisInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Использовать внешние эмодзи")
	return /** @type {LocalizedString} */ ("Use External Emojis")
});